'use strict';
import React from 'react';

class FactoryCellInterface {
  constructor (user, domain) {
    this.user = user;
    this.domain = domain;
  }

  /**
   * Тип недвижимости
   * @param key
   * @param data
   * @returns {*}
   */
  makeRealtyType (key, data) {
    return <td key={key} />;
  }

  /**
   * Описание
   * @param key
   * @param data
   * @returns {*}
   */
  makeDescription (key, data, eventAddFavorites, eventRemoveFavorites, eventOpenCommentForm, eventOpenClaimForm, eventMapModal) {
    return <td key={key} />;
  }

  /**
   * Описание расширенное с типом недвижимости
   * @param key
   * @param data
   * @returns {*}
   */
  makeDescriptionAndType (key, data, eventAddFavorites, eventRemoveFavorites, eventOpenCommentForm, eventOpenClaimForm, eventMapModal) {
    return <td key={key} />;
  }

  /**
   * Цена
   * @param key
   * @param data
   * @returns {*}
   */
  makePrice (key, data) {
    return <td key={key} />;
  }

  /**
   * Цена общая
   * @param key
   * @param data
   * @returns {*}
   */
  makePriceTotal (key, data) {
    return <td key={key} />;
  }

  /**
   * Цена и плата
   * @param key
   * @param data
   * @returns {*}
   */
  makePriceAndPay (key, data) {
    return <td key={key} />;
  }

  /**
   * Цена и цена за кв.м.
   * @param key
   * @param data
   * @returns {*}
   */
  makePriceAndPricePerMeter (key, data) {
    return <td key={key} />;
  }

  /**
   * Цена за кв.м.
   * @param key
   * @param data
   * @returns {*}
   */
  makePricePerMeter (key, data) {
    return <td key={key} />;
  }

  /**
   * Площадь
   * @param key
   * @param data
   * @returns {*}
   */
  makeArea (key, data) {
    return <td key={key} />;
  }

  /**
   * Здание
   * @param key
   * @param data
   * @returns {*}
   */
  makeBuilding (key, data) {
    return <td key={key} />;
  }

  /**
   * Контакты
   * @param key
   * @param data
   * @param onUpdateFilter
   * @returns {*}
   */
  makeContacts (key, data, onUpdateFilter, eventShowContacts, rawData) {
    return <td key={key} />;
  }

  /**
   * Информация о недвижимости
   * @param key
   * @param data
   * @returns {*}
   */
  makeMoreProperty (key, data) {
    return <td key={key} />;
  }

  /**
   * Дата
   * @param key
   * @param data
   * @returns {*}
   */
  makeDate (key, data) {
    return <td key={key} />;
  }

  /**
   * Земля
   * @param key
   * @param data
   * @returns {*}
   */
  makeLand (key, data) {
    return <td key={key} />;
  }

  /**
   * Адрес
   * @param key
   * @param data
   * @returns {*}
   */
  makeAddress (key, data, eventClickAnnouncement, rawData) {
    return <td key={key} />;
  }

  /**
   * Фото
   * @param key
   * @param data
   * @returns {*}
   */
  makePhotos (key, data, eventClickAnnouncement, rawData) {
    return <td key={key} />;
  }

  /**
   * Материал
   * @param key
   * @param data
   * @returns {*}
   */
  makeMaterial (key, data) {
    return <td key={key} />;
  }

  /**
   * Продавец
   * @param key
   * @param data
   * @returns {*}
   */
  makeSeller (key, data) {
    return <td key={key} />;
  }

  /**
   * Этаж
   * @param key
   * @param data
   * @returns {*}
   */
  makeFloor (key, data) {
    return <td key={key} />;
  }

  /**
   * Размер здания
   * @param key
   * @param data
   * @returns {*}
   */
  makeBuildingSize (key, data) {
    return <td key={key} />;
  }

  /**
   * Условия сделки
   * @param key
   * @param data
   * @returns {*}
   */
  makeDealCondition (key, data) {
    return <td key={key} />;
  }

  /**
   * Пустая ячейка
   * @param key
   * @returns {*}
   */
  makeEmpty (key) {
    return <td key={key}> --- </td>;
  }
}

export default FactoryCellInterface;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/Factory/FactoryCellInterface.jsx